
export const RESIZE_ROOM = 'ui/RESIZE_ROOM';
export const SWITCH_INFO_PANEL_TAB = 'ui/SWITCH_INFO_PANEL_TAB';
export const RESIZE_TEXTAREA = 'ui/RESIZE_TEXTAREA';
export const CHANGE_COLOR_THEME = 'ui/CHANGE_COLOR_THEME';

export const resizeRoom = height => ({
  type: RESIZE_ROOM,
  payload: height,
});

export const switchInfoPanelTab = tabName => ({
  type: SWITCH_INFO_PANEL_TAB,
  payload: tabName,
});

export const resizeTextarea = height => ({
  type: RESIZE_TEXTAREA,
  payload: height,
});

export const changeColorTheme = newColorTheme => ({
  type: CHANGE_COLOR_THEME,
  payload: newColorTheme,
})
